import Grid from "@material-ui/core/Grid";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import MyYuukke from "../../../api/MyYuukke";
import PeopleCard from "../../../components/PeopleCard";
import i18n from "../../../i18n";
import AuthService from "../../../session/AuthService";

class PeoplesCarouselList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recommendedFriendsList: [],
      recommendedFriendsListState: false,
      searchList: [],
    };
    this.getRecommendedFriendsList = this.getRecommendedFriendsList.bind(this);
    this.requestSentPage = this.requestSentPage.bind(this);
    this.gotoSearchPage = this.gotoSearchPage.bind(this);
    this.ignoreSentPage = this.ignoreSentPage.bind(this);
    this.searchMembers = this.searchMembers.bind(this);
  }
  componentDidMount() {
    this.getRecommendedFriendsList(
      this.props.recommended_friends_list,
      this.props.recommendedListLength
    );
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.recommended_friends_list !== this.props.recommended_friends_list
    ) {
      this.getRecommendedFriendsList(
        this.props.recommended_friends_list,
        this.props.recommendedListLength
      );
    }
  }

  render() {
    const { t } = this.props;


    return (
      <div className="peopleCarouselWrapper">
        <div className="searchHeading flexDefault flexAlignCenter flexJustifySpacebetween">
          <div>
            <p className="boldLabel">{t("People you may know")}</p>
          </div>

          <div
            style={{ cursor: "pointer", display: "inline-flex" }}
            onClick={this.gotoSearchPage}
          >
            <ArrowBackIcon style={{ color: "rgba(69, 109, 149, 1)" }} />
            <p
              className="boldLabel"
              style={{ color: "rgba(69, 109, 149, 1)", cursor: "pointer" }}
            >
              {t("Back to search")}
            </p>
          </div>
        </div>

        <Grid container spacing={2}>
          {this.state.searchList &&
            this.state.searchList.map((people, index) => {
              return (
                <Grid item xs={12} sm={12} md={6} lg={3} key={index}>
                  <React.Fragment key={index}>
                    <PeopleCard
                      userId={people.uId}
                      Dname={people.dName}
                      // subjects={people.user.userLearn}
                      name={`${people.firstName} ${people.lastName}`}
                      biography={people.biography}
                      requestSent={this.requestSentPage}
                      ignoreSent={this.ignoreSentPage}
                    />
                  </React.Fragment>
                </Grid>
              );
            })}

          {this.state.searchList.length === 0 && (
            <div class="no-data">
              <center>
                <p>{t("No Results Found")}</p>
              </center>
            </div>
          )}
          {/* </Slider> */}
        </Grid>
      </div>
    );
  }
  searchMembers(value) {


    let search  = value !== null ? { searchKey: value } : { searchKey: "" };
    MyYuukke.searchUsers(search)
      .then((response) => {
        var result = response.data;

        var stringArray = result.data.searchList;

        if (stringArray.length > 0) {
          this.setState({
            searchList: stringArray,
          });
        } else {
          this.setState({
            searchList: [],
          });
        }
        if (value === null || value === "") {
          this.setState({
            searchList: this.props.recommended_friends_list,
          });
        }

      })

      .catch((error) => {
        console.log(error);
      });
  }

  ignoreSentPage() {
    this.props.ignoreSentPageData();
  }
  requestSentPage() {
    this.props.requestSentPageData();
  }
  async getRecommendedFriendsList(
    recommended_friends_list,
    recommendedListLength
  ) {
    if (recommended_friends_list.length > 0) {
      await this.setState({
        searchList: recommended_friends_list,
        recommendedFriendsListState: false,
        recommendedListLengths: recommendedListLength,

      });
    } else {
      await this.setState({
        recommendedFriendsListState: true,
        recommendedListLengths: recommendedListLength,

      });
    }
  }

  gotoSearchPage() {
    this.props.history.push({

      pathname: `/${this.props.workspaceType}/mynetwork`,
    });
  }
}
const mapStateToProps = function (state) {
  return {
    workspaceType: state.loginDetailsApi.loginDetails.userWorkSpace?.slug,
    loginDetails: state.loginDetailsApi.loginDetails,
  };
};

export default connect(
  mapStateToProps,
  null
)(withTranslation()(withRouter(PeoplesCarouselList)));
